import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();

(function($) {
	$(document).ready(function() {
		$('.fancy-form').fancybox();
		$('.fancy-img').fancybox();

		// add now year
		var currentYear = new Date().getFullYear();
		$(".copyright_box .now_year").prepend(currentYear+" ");

		function checkMyCookies(){
			let cookieDate = localStorage.getItem('cookieDate');
			let cookieNotification = document.getElementById('cookie_notifys');
			let cookieBtn = cookieNotification.querySelector('.notifys__apply');
			if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
				cookieNotification.classList.add('show');
			}
			cookieBtn.addEventListener('click', function(){
				localStorage.setItem( 'cookieDate', Date.now() );
				cookieNotification.classList.remove('show');
			})
		}
		checkMyCookies();
	});
})(jQuery);